import { withNamespaces } from '@/i18n/route-namespaces'

export const dashboardsRoutes = {
  path: 'dashboards',
  children: [
    {
      path: ':dashboardId',
      lazy: withNamespaces(['dashboards'], async () => {
        const { DashboardDetail } = await import('@/pages/dashboards/detail')

        return { Component: DashboardDetail }
      }),
    },
  ],
}
